import { CloseCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { convertMinutes } from '../../utils/time';
import * as React from 'react';
import { FormLayoutRow } from '../form-layout-row/form-layout-row';
import { Form, Input, Select, Switch, Tooltip } from 'antd';
import { getClassNames } from '../../utils';
var freqCapDisplay = function freqCapDisplay(domain) {
  var _domain$notificationF;
  if (!domain || !((_domain$notificationF = domain.notificationFrequencyCaps) !== null && _domain$notificationF !== void 0 && _domain$notificationF[0])) {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(CloseCircleOutlined, null), " No Frequency Cap");
  }
  var freqCap = domain.notificationFrequencyCaps[0];
  var notifCapStr = freqCap.value,
    metric = freqCap.displayMetric,
    minutes = freqCap.durationMinutes;
  var durationCap = metric ? convertMinutes(minutes, metric) : minutes;
  return "A subscriber may receive ".concat(notifCapStr, " notification").concat(notifCapStr > 1 ? 's' : '', " every ").concat(durationCap, " ").concat(metric, ".");
};
export function extractUIFriendlyCap(cap) {
  if (cap === null || cap === undefined) {
    return cap;
  }
  var displayCap = {
    value: cap.value,
    durationMinutes: cap.durationMinutes
  };
  if (cap.displayMetric) {
    displayCap.durationMinutes = convertMinutes(displayCap.durationMinutes, cap.displayMetric);
    displayCap.displayMetric = cap.displayMetric;
  }
  return displayCap;
}
export var NotificationFrequencyCapsDisplay = function NotificationFrequencyCapsDisplay(_ref) {
  var domain = _ref.domain;
  return /*#__PURE__*/React.createElement("div", {
    className: "notification-frequency-cap-display"
  }, /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: "Frequency Cap",
    value: freqCapDisplay(domain)
  }));
};
export var determineMinMax = function determineMinMax(metric) {
  switch (metric) {
    case 'hours':
      return [1, 168];
    case 'days':
      return [1, 7];
    case 'minutes':
    default:
      return [5, 10080];
  }
};
export var NotificationFrequencyCapsFormEditor = function NotificationFrequencyCapsFormEditor(_ref2) {
  var enabled = _ref2.enabled,
    handleEnabled = _ref2.handleEnabled;
  return /*#__PURE__*/React.createElement("div", {
    className: getClassNames('notif-frequency-caps-editor')
  }, /*#__PURE__*/React.createElement(Form.Item, {
    label: /*#__PURE__*/React.createElement("span", null, "Frequency Caps", /*#__PURE__*/React.createElement(Tooltip, {
      title: "The frequency cap determines the maximum number of notifications a subscriber can receive within the specified period of time."
    }, /*#__PURE__*/React.createElement(InfoCircleOutlined, null)))
  }, /*#__PURE__*/React.createElement("div", {
    className: "notif-frequency-caps"
  }, /*#__PURE__*/React.createElement(Switch, {
    size: "small",
    checked: enabled,
    onChange: function onChange(checked) {
      handleEnabled(checked);
    }
  }), /*#__PURE__*/React.createElement("div", null, "A subscriber may receive"), /*#__PURE__*/React.createElement("div", {
    className: "notif-frequency-caps-inputs ".concat(enabled ? '' : 'disabled')
  }, /*#__PURE__*/React.createElement(Form.Item, {
    name: ['notificationFrequencyCaps', 'value'],
    noStyle: true
  }, /*#__PURE__*/React.createElement(Input, {
    disabled: !enabled,
    size: "middle",
    type: "number",
    min: 1,
    max: 100,
    addonAfter: "notification(s)"
  })), /*#__PURE__*/React.createElement("div", {
    className: "notif-fcap-input-seperator"
  }, "every"), /*#__PURE__*/React.createElement(Form.Item, {
    noStyle: true,
    shouldUpdate: function shouldUpdate(prev, curr) {
      var _prev$notificationFre, _curr$notificationFre;
      return !!curr.notificationFrequencyCaps && ((_prev$notificationFre = prev.notificationFrequencyCaps) === null || _prev$notificationFre === void 0 ? void 0 : _prev$notificationFre.displayMetric) !== ((_curr$notificationFre = curr.notificationFrequencyCaps) === null || _curr$notificationFre === void 0 ? void 0 : _curr$notificationFre.displayMetric);
    }
  }, function (_ref3) {
    var _getFieldValue, _getFieldValue2;
    var getFieldValue = _ref3.getFieldValue;
    return /*#__PURE__*/React.createElement(Form.Item, {
      name: ['notificationFrequencyCaps', 'durationMinutes']
    }, /*#__PURE__*/React.createElement(Input, {
      disabled: !enabled,
      className: "duration-group",
      size: "middle",
      type: "number",
      min: determineMinMax((_getFieldValue = getFieldValue('notificationFrequencyCaps')) === null || _getFieldValue === void 0 ? void 0 : _getFieldValue.displayMetric)[0],
      max: determineMinMax((_getFieldValue2 = getFieldValue('notificationFrequencyCaps')) === null || _getFieldValue2 === void 0 ? void 0 : _getFieldValue2.displayMetric)[1],
      addonAfter: /*#__PURE__*/React.createElement(Form.Item, {
        name: ['notificationFrequencyCaps', 'displayMetric'],
        noStyle: true
      }, /*#__PURE__*/React.createElement(Select, {
        size: "middle",
        disabled: !enabled
      }, /*#__PURE__*/React.createElement(Select.Option, {
        value: "minutes"
      }, "minute(s)"), /*#__PURE__*/React.createElement(Select.Option, {
        value: "hours"
      }, "hour(s)"), /*#__PURE__*/React.createElement(Select.Option, {
        value: "days"
      }, "day(s)")))
    }));
  })))));
};